<template>
    <div id="moveSearch">
        <a-modal
                title="Move"
                :visible="visible"
                width="85%"
                @cancel="handleCancelTable"
        >

        <!-- save 按钮 -->
            <template slot="footer">
                <a-button type="primary" @click="AdjustTableSelect" size="small" >{{ $t('publicLang.Save') }}</a-button>
            </template>

            <a-row>
                <a-row >
                     <!-- 分页 -->
                    <a-row type="flex" justify="space-between">
                        <a-col></a-col>
                        <a-col>
                            <div style="display: flex;justify-content: center">
                                <a-pagination
                                        size="small"
                                        :total="page.pagingTotal"
                                        v-model="page.currentVal"
                                        :pageSize.sync="page.pagingSize"
                                        @change="tableChangePage"
                                        @showSizeChange="onShowSizeChange"
                                        showSizeChanger

                                />
                                <a-dropdown>
                                    <span class="sbxs">
                                        <img class="sbxs" src="../../../../assets/img/ss-more.png"  width="22" height="22">
                                    </span>
                                    <a-menu slot="overlay">
                                        <a-menu-item style="font-size: 12px" @click="AdvanceSearch">
                                            <a-icon type="zoom-in" /> {{ $t('pubGicSet.AdvanceSearch') }}
                                        </a-menu-item>
                                    </a-menu>
                                </a-dropdown>
                            </div>
                        </a-col>
                    </a-row>

                    <!-- table  -->
                    <a-row style="margin-top: 4px;text-align: center" >
                        <a-spin :spinning="adjustLoading">
                            <vxe-table
                                    ref="adjustTable"
                                    stripe
                                    highlight-current-row
                                    @checkbox-change="selectChangeEvent"
                                    @checkbox-all="selectChangeEvent"
                                    border
                                    resizable
                                    size="mini"
                                    :data.sync="tableData"
                                    :loading="adjustLoading"
                                    max-height="350"
                                    :radio-config="{labelField: 'name', trigger: 'row'}"
                                    v-if="cols.length > 0"
                            >
                                <template v-slot:empty>
                                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                                </template>
                                <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                                <template v-for="(item, index) in cols">
                                    <vxe-table-column show-header-overflow show-overflow  :width="item.proWidth == null ? '200' : item.proWidth" :key="index">
                                        <template v-slot:header="{ column }">
                                            <a-tooltip placement="topLeft">
                                                <template slot="title">
                                                    <span>{{item.description == null ? "-" : item.description}}</span>
                                                </template>
                                                <span> {{ item.title }}</span>
                                            </a-tooltip>
                                        </template>
                                        <template v-slot="{ row }">
                                            <a-tooltip placement="topLeft">
                                                <template slot="title">
                                                    <span>{{row[item.label].value == null ? "-" : row[item.label].value}}</span>
                                                </template>
                                                <span style="fontSize: 12px;height: 30px;line-height: 30px;display: block;">{{row[item.label].value == null ? "-" : row[item.label].value}}</span>
                                            </a-tooltip>
                                        </template>
                                    </vxe-table-column>
                                </template>

                                <!-- Qty -->
                                <vxe-table-column fixed="right" title="Qty" width="100">
                                    <template v-slot="{ row }">
                                        <a-row>
                                            <a-input-number @change="ainputNumchange(row)" :min="1" style="width: 100%;" v-model="row.qty" size="small"  :placeholder="$t('publicLang.PleaseEnter')"/>
                                        </a-row>
                                    </template>
                                </vxe-table-column>

                                <!-- toLocation  -->
                                <vxe-table-column  width="200"  fixed="right" field="toLocation" title="To Location" show-header-overflow show-overflow>
                                    <template v-slot="{ row }">
                                        <a-auto-complete
                                                style="width: 100%"
                                                @search="searchMovehandleSearch"
                                                :placeholder="$t('publicLang.PleaseEnter')"
                                                size="small"
                                                v-model="row.toLocation"
                                        >
                                            <template slot="dataSource">
                                                <a-select-option v-for="item in moveCompleteData"  :key="item.locationCode" :value="item.locationName">{{item.locationName}}</a-select-option>
                                            </template>
                                        </a-auto-complete>
                                    </template>
                                </vxe-table-column>

                            </vxe-table>
                        </a-spin>
                    </a-row>

                </a-row>
                <a-divider dashed style="margin: 4px 0"/>
            </a-row>


            <a-modal
                    :title="$t('pubGicSet.AdvanceSearch')"
                    :visible="AdjustAdvanVis"
                    @cancel="handleAdjustAdvan"
                    width="85%">
                <template slot="footer">
                    <a-button type="primary" @click="adjustAdvanSearch" size="small">{{ $t('pubGicSet.Search') }}</a-button>
                </template>
                <and-or :options="options" :isFirst="isFirst" ref="adjustAndor" style="margin-bottom: 10px;"></and-or>
            </a-modal>
        </a-modal>
        <!--advanSearch -->

        <move-split ref="moveSplit" v-on:splitMove="getSplitMove"></move-split>
    </div>
</template>
<script>
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    import andOr from "../../../com/queryBuilder/components/AndOR.vue";
    import moveSplit from './moveSplit.vue'
    import { mapState } from "vuex";
    import cookie from '../../../../api/cookie';

    export default{
        components:{
            andOr,
            moveSplit,
        },
        props:{
            waseCode:{
                type: String,
                default: function() {
                    return '';
                }
            },
            ajtype:{
                type: String,
                default: function() {
                    return '';
                }
            },
            adjustParHeaderId: {
                type: String,
                default: function() {
                    return '';
                }
            },
            searTableUid: {
                type: String,
                default: function() {
                    return '';
                }
            },
        },
        data(){
            return{
                transFerView: true,
                ifEditTransfer: true,
                page:{
                    pagingTotal: 0,
                    currentVal: 1,
                    pagingSize: 30
                }, // 分页
                radioRows: [], // advan serach 后 table 选中的信息
                tableData: [], // serach table data
                cols: [],  // serach table cloumns
                visible: false,
                AdjustAdvanVis: false,
                isFirst: true,
                options: {
                    condition: [],
                    fieldNameSel: []
                },
                adjustLoading: false,
                moveTransferTable: [],
                moveCompleteData: [],
//                tranferName
                transferFieldname: undefined,
                transferFieldnameSelect: [],
                traneferFieldnameTable: [],
//                putaway 查询条件
                putawayInfo: {},
                editTransfer: {},
                batchNo: 0
            }
        },
        computed: {
            ...mapState(["lang"]),
        },
        methods:{
            getAvQty(){
                for (let i = 0; i < this.cols.length; i++) {
                    if(this.cols[i].title == 'AV MOVE QTY'){
                        return this.cols[i].label;
                    }
                }
                return null;
            },
            getToLocation(){
                for (let i = 0; i < this.cols.length; i++) {
                    if(this.cols[i].title == 'LOCATION CODE'){
                        return this.cols[i].label;
                    }
                }
                return null;
            },
            ainputNumchange(val){
                this.$nextTick(()=>{
                    this.$refs.adjustTable.setCheckboxRow([val],true)
                    this.radioRows = this.$refs.adjustTable.getCheckboxRecords()
                })
            },
            moveSplit(){
                ajax.get(api.INVENTORYMOVESPLIT,{uid: this.radioRows[0].uid}).then(res=>{
                    if(res.code == 200){
                        let tt = {
                            headerUid: this.adjustParHeaderId,
                            userSqlDto:this.$refs.adjustAndor.queryFormStatus(),
                            invVos: res.data,
                            markStr: this.ajtype,
                            waseCode: this.waseCode
                        }
                        this.$refs.moveSplit.show(tt)
                    }else{
                        this.$customMessage.error(this.$t('pubGicSet.NotAllowToSplit'));
                        return
                    }
                })

            },
            addtransferName(){
                if(this.transferFieldname == undefined){
                    this.$customMessage.error(this.$t('pubGicSet.PleaseSelectFieldName'));
                    return
                }
                if(this.traneferFieldnameTable.length > 0){
                    for(let ii in this.traneferFieldnameTable){
                        if(this.traneferFieldnameTable[ii].fieldname == this.transferFieldname){
                            this.$customMessage.error(this.$t('pubGicSet.FieldAddedRepeatedly'));
                            return
                        }
                    }
                }
                this.traneferFieldnameTable.push({fieldname: this.transferFieldname,toValue: ''})
            },
            deleteTransferName(){
                let selectData = this.$refs.transferFilednameTable.getCheckboxRecords();

                for(let ii in this.traneferFieldnameTable){
                    for(let jj in selectData){
                        if(this.traneferFieldnameTable[ii].fieldname == selectData[jj].fieldname){
                            this.traneferFieldnameTable.splice(ii,1);
                        }
                    }
                }

                this.$refs.transferFilednameTable.removeCheckboxRow();
            },
            searchMovehandleSearch(val){
                if(val.length < 4){
                    return
                }
                let params = {
                    whsCode: this.waseCode,
                    keyword: val,
                }
                ajax.post(api.INVENTORYLOCATION,params).then(res=>{
                    this.moveCompleteData = res.data
                })
            },
            onShowSizeChange(page,pageSize){
                this.page.currentVal = 1
                this.page.pagingSize = pageSize
                this.adjustAdvanSearch()
            },
            tableChangePage(current){
                this.page.currentVal = current
                this.adjustAdvanSearch()
            },
            show(type,obj,batchNo){
                this.batchNo = batchNo;
                this.editTransfer = obj
                this.visible = true
                this.AdjustAdvanVis = true
                this.$nextTick(()=>{
                    this.$refs.adjustAndor.fillFormStatus(null);
                })
                this.init(type)
            },
            handleCancelTable(){
                this.visible = false
                this.transferFieldname = undefined
                this.traneferFieldnameTable = []
            },
            handleAdjustAdvan(){
                this.AdjustAdvanVis = false
            },
            AdvanceSearch(){
                this.AdjustAdvanVis = true
            },
//            初始化数据
            init(type){
          
                if(type == 'T'){
                    this.$nextTick(()=>{
                        this.ifEditTransfer = false
                        this.adjustAdvanSearch()
                    })
                }
                if(type == 'view'){
                    this.$nextTick(()=>{
                        this.ifEditTransfer = false
                        this.adjustAdvanSearch()
                        let arr = []
                        for(let i in this.editTransfer){
                            arr.push({fieldname:this.editTransfer[i].key,toValue: this.editTransfer[i].value})
                        }
                        this.traneferFieldnameTable = arr
                        // this.transFerView = false
                    })
                }
                // else{
                //      this.transFerView = true;
                // }
                this.ifEditTransfer = true
                ajax.get(api.GETSQLDROPDATA).then(res => {
                    this.options.condition = res.data.condition;
                });
                let params = {
                    gmcUid: this.searTableUid
                };
                ajax.post(api.GETFIELDNAMEDROPDATA, params).then(res => {
                    let data = res.data
                    let type = '='
                    if(this.ajtype == 'invMoveDetail'){
                        type = '<>'
                    }
                    this.putawayInfo = {
                        'condition': 'AND',
                        rules: []
                    }
                    for(let i in data){
                        if(data[i].fieldName == "LOCATION TYPE"){
                            this.putawayInfo.rules.push({
                                boolValue: false,
                                flName: data[i].detailUid,
                                flType: "String",
                                numVal: "",
                                operator: type,
                                textSearchval: "Staging@##@",
                                timeValue: ''
                            })
                        }
                        if(data[i].fieldName == "WAREHOUSE CODE" ){
                            this.putawayInfo.rules.push({
                                boolValue: false,
                                flName: data[i].detailUid,
                                flType: "String",
                                numVal: "",
                                operator:'=',
                                textSearchval: this.waseCode +"@##@",
                                timeValue: ''
                            })
                        }
                    }
                    this.options.fieldNameSel = data
                });



                this.traneferFieldnameTable = []
             this.transferFieldname = undefined

                this.tableData = []
                this.cols = []
                if(this.ajtype == 'transferDetail'){
                    ajax.get(api.INVENTORYFIELDNAME).then(res=>{
                        this.transferFieldnameSelect = res.data.fieldNames
                    })
                }
                this.AdjustAdvanVis = true
            },
//            search 搜索后的table
            adjustAdvanSearch(){
                this.adjustLoading = true
                let searcQuery= this.$refs.adjustAndor.queryFormStatus()
                if(this.ajtype == 'puatWay' || this.ajtype == 'invMoveDetail'){
                    searcQuery.rules.push(this.putawayInfo)
                }
                let params = {
                    gmcUid: this.searTableUid,
                    language: this.lang,
                    userSqlDto: searcQuery,
                    paging: {
                        pageNum: this.page.currentVal,
                        pageSize: this.page.pagingSize
                    }
                };
                this.AdjustAdvanVis = false
                this.visible = true
                ajax.post(api.SKUS, params).then(res=>{
                    if(res.code == 200){
                        this.adjustLoading = false
                        this.cols = res.data.tableList.columns
                        let arryNew = res.data.tableList.data;
                     
                        if(this.ajtype == 'Transfer' || this.ajtype == 'transferDetail'){
                             
                        for (let i = 0; i < arryNew.length; i++) {
                            
                            arryNew[i].qty = this.getAvQty() == null ? 1 : arryNew[i][this.getAvQty()].value
                            arryNew[i].toLocation = this.getToLocation() == null ? '' : arryNew[i][this.getToLocation()].value
                            this.tableData.push(arryNew[i])
                        }
                        }else{
                            this.tableData = arryNew;
                        }
                        this.page.pagingTotal =res.data.tableList.paging.totalPageSize
                    }
                })
            },
//            table 选中 提交ajax aj move
            AdjustTableSelect(){
                let arr =[]
                this.radioRows = this.$refs.adjustTable.getCheckboxRecords()
                if(this.radioRows.length > 0){
                    for(let ii in this.radioRows){
                        if(this.ajtype == 'invMoveDetail' || this.ajtype == 'puatWay'){
                            // if(this.radioRows[ii].toLocation == undefined || this.radioRows[ii].toLocation == ''){
                            //     this.$customMessage.error(this.$t('pubGicSet.ToLocationRequired'));
                            //     return
                            // }
                            if(this.radioRows[ii].qty == undefined || this.radioRows[ii].qty == ''){
                                this.$customMessage.error(this.$t('pubGicSet.QtyRequired'));
                                return
                            }
                            arr.push({uid: this.radioRows[ii].uid,qty: this.radioRows[ii].qty, toLocation: this.radioRows[ii].toLocation})
                        }else{
                            arr.push({uid: this.radioRows[ii].uid})
                        }
                    }
                }else{
                    this.$customMessage.error(this.$t('publicLang.PleaseSltAtleast'));
                    return
                }
                let params = {
                    headerUid: this.adjustParHeaderId,
                    userSqlDto:this.$refs.adjustAndor.queryFormStatus(),
                    invVos: arr
                }
             
                 params.markStr = 'invMoveDetail'
                ajax.post(api.INVDETAILPUB,params).then(res=>{
                    if(res.code == 200){
                        if(this.ajtype == 'invMoveDetail' || this.ajtype == 'puatWay'){
                            ajax.get(api.INVENTORYINVMOVEINFO,{uid: this.adjustParHeaderId}).then(res=>{
                                this.$emit('getAdjustData', res.data.invMoveDetailDtos)
                            })
                        }
                        this.visible = false
                        this.radioRows = []
                    }else{
                        this.$customMessage.error(res.msg);
                    }
                })
            },
//            table 选中 应该没什么用咯
            selectChangeEvent({selection}){
                this.radioRows = selection
            },
            getSplitMove(val){
                this.visible = false
                this.$emit('getAdjustData',val)
            }
        }
    }
</script>